'use client';
import { useEffect } from 'react';
import { useResponsiveStore } from '@/store/useResponsiveStore';

export const useResponsive = () => {
  const { 
    isMobile, 
    isTablet, 
    isDesktop, 
    isLoaded, 
    isMobileOrTablet, 
    initializeResponsive 
  } = useResponsiveStore();

  useEffect(() => {
    const cleanup = initializeResponsive();
    return cleanup;
  }, [initializeResponsive]);

  return {
    isMobile,
    isTablet,
    isDesktop,
    isMobileOrTablet,
    isLoaded
  };
}; 